/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Save_Overwrite_ButtonInputs */

const en_explorer_info_save_overwrite_button = /** @type {(inputs: Explorer_Info_Save_Overwrite_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save & Overwrite`)
};

const fr_explorer_info_save_overwrite_button = /** @type {(inputs: Explorer_Info_Save_Overwrite_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer et ecraser`)
};

const de_explorer_info_save_overwrite_button = /** @type {(inputs: Explorer_Info_Save_Overwrite_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichern & Überschreiben`)
};

const it_explorer_info_save_overwrite_button = /** @type {(inputs: Explorer_Info_Save_Overwrite_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva e sovrascrivi`)
};

const ru_explorer_info_save_overwrite_button = /** @type {(inputs: Explorer_Info_Save_Overwrite_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранить и перезаписать`)
};

const es_explorer_info_save_overwrite_button = /** @type {(inputs: Explorer_Info_Save_Overwrite_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar y sobrescribir`)
};

const zh_cn2_explorer_info_save_overwrite_button = /** @type {(inputs: Explorer_Info_Save_Overwrite_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存并覆盖`)
};

const ja_explorer_info_save_overwrite_button = /** @type {(inputs: Explorer_Info_Save_Overwrite_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存して上書き`)
};

const hi_explorer_info_save_overwrite_button = /** @type {(inputs: Explorer_Info_Save_Overwrite_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सहेजें और ओवरराइट करें`)
};

const pt_pt2_explorer_info_save_overwrite_button = /** @type {(inputs: Explorer_Info_Save_Overwrite_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar e sobrescrever`)
};

/**
* | output |
* | --- |
* | "Save & Overwrite" |
*
* @param {Explorer_Info_Save_Overwrite_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_save_overwrite_button = /** @type {((inputs?: Explorer_Info_Save_Overwrite_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Save_Overwrite_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_save_overwrite_button(inputs)
	if (locale === "de") return de_explorer_info_save_overwrite_button(inputs)
	if (locale === "it") return it_explorer_info_save_overwrite_button(inputs)
	if (locale === "ru") return ru_explorer_info_save_overwrite_button(inputs)
	if (locale === "es") return es_explorer_info_save_overwrite_button(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_save_overwrite_button(inputs)
	if (locale === "ja") return ja_explorer_info_save_overwrite_button(inputs)
	if (locale === "hi") return hi_explorer_info_save_overwrite_button(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_save_overwrite_button(inputs)
	return en_explorer_info_save_overwrite_button(inputs)
});